module.exports = __webpack_public_path__ + "static/media/apple_store.8846e039.svg";